export const DEFAULT_CONTACT_DATE_FILTER_ENGAGEMENT = 1
export const DEFAULT_CONTACT_DATE_FILTER_CREATED_AT = 2
